import { incYenOf, incOf } from '../lib/pricing';
export const courseOverview = {
  name: 'エッセンシャルコース',
  nameEn: 'ESSENTIAL COURSE',
  duration: '1ヶ月',
  days: '8日間',
  totalHours: '48時間',
  price: incYenOf('ac-essential'),
  schedule: '7月・1月開校',
  classFormat: '土日開催・1日6時間（90分×4コマ）',
  capacity: '完全少人数制（定員6名）',
  target: '初心者・キャリアチェンジ希望者',
};

export const trustBadges = [
  {
    icon: 'ri-group-line',
    text: '定員6名の完全少人数制',
  },
  {
    icon: 'ri-calendar-check-line',
    text: '土日開催・働きながら学べる',
  },
  {
    icon: 'ri-award-line',
    text: '修了で協会認定資格',
  },
];

export const targetAudienceItems = [
  {
    icon: 'ri-user-star-line',
    text: '執事として新たなキャリアを始めたい方',
  },
  {
    icon: 'ri-building-2-line',
    text: '接客・サービス業から専門性を高めたい方',
  },
  {
    icon: 'ri-home-heart-line',
    text: '家庭や職場で本物のおもてなしを身につけたい方',
  },
  {
    icon: 'ri-stairs-line',
    text: 'マスターコースへの段階的なステップを望む方',
  },
];

export const learningContents = [
  {
    id: 'manners',
    title: '基本マナーとエチケット',
    titleEn: 'Manners & Etiquette',
    description: '挨拶・姿勢・歩き方・ドアの開閉・ご案内の所作など、執事の全業務の土台となる立ち居振る舞いを習得します。鏡を使った自己チェックと講師による個別指導で、自然で品格ある所作が身につきます。',
    icon: 'ri-user-smile-line',
    imageSeq: 'learning-manners',
  },
  {
    id: 'housekeeping',
    title: '日常的な家事管理',
    titleEn: 'Household Management',
    description: '清掃と整理整頓の段取り、買い物と在庫の管理など、家政を「こなす」のではなく「管理する」視点を学びます。チェックリストを用いた効率的な巡回管理の手法を実践的に習得します。',
    icon: 'ri-home-3-line',
    imageSeq: 'learning-housekeeping',
  },
  {
    id: 'table-setting',
    title: '基本的なテーブルセッティング',
    titleEn: 'Table Setting',
    description: 'カトラリーとグラスの正しい配置、ナプキンの扱い方を学びます。朝食からディナーまでの基本形を実物の食器を用いて繰り返し練習し、どんな場面でも美しいテーブルを整えられるようになります。',
    icon: 'ri-restaurant-line',
    imageSeq: 'learning-table',
  },
  {
    id: 'tea-coffee',
    title: '紅茶とコーヒーの淹れ方',
    titleEn: 'Tea & Coffee Service',
    description: '茶葉と豆の基礎知識、温度と時間の管理、美しい注ぎ方と提供の所作を体系的に学びます。テイスティング演習を通じて味覚も鍛え、受講生の皆様が自信を持ってサービスできる水準を目指します。',
    icon: 'ri-cup-line',
    imageSeq: 'learning-tea',
  },
  {
    id: 'clothing-care',
    title: '衣類の手入れ',
    titleEn: 'Garment Care',
    description: 'シャツのアイロンがけ、ブラッシング、保管の基本を実習中心で学びます。生地の種類に応じた適切な温度管理と、美しい仕上げのコツを習得し、衣類を長く最良の状態で保つ技術が身につきます。',
    icon: 'ri-t-shirt-2-line',
    imageSeq: 'learning-ironing',
  },
  {
    id: 'communication',
    title: '基本的なコミュニケーション技術',
    titleEn: 'Communication Skills',
    description: '品格ある言葉遣い、適切な距離感の取り方、報告・連絡・相談の作法をロールプレイング形式で学びます。相手に安心感と信頼感を与えるコミュニケーションの基礎を、実践的な演習を通じて習得します。',
    icon: 'ri-chat-1-line',
    imageSeq: 'learning-communication',
  },
];

export const dailySchedule = [
  { time: '10:00 – 11:30', title: '理論講義', description: '各回のテーマに沿った座学。教科書と映像教材を用いて基礎知識を体系的に学びます。' },
  { time: '11:45 – 13:15', title: '実技演習', description: '講師のデモンストレーションの後、受講生お一人ずつ実践。少人数制のため丁寧な個別指導が受けられます。' },
  { time: '13:15 – 14:00', title: '昼食休憩', description: '' },
  { time: '14:00 – 15:30', title: 'ロールプレイング実習', description: '実際の邸宅やホテルを想定したシチュエーション演習。受講生同士で執事役と依頼者役を交互に体験します。' },
  { time: '15:45 – 17:15', title: '実技＋振り返り', description: '午前の実技の応用演習と、その日の学びを講師とともに振り返るレビューセッション。質疑応答の時間も設けています。' },
];

export const certificationInfo = {
  title: '修了実技試験と認定資格',
  titleEn: 'Certification Exam',
  description: 'コース最終日に実施する修了実技試験（テーブルセッティングとティーサービスの実演）に合格すると、以下の認定資格が授与されます。',
  qualification: '認定アソシエイトバトラー（Certified Associate Butler）',
  badge: '認定ピンバッジ',
  note: '※当資格は一般社団法人全日本執事協会が独自に認定する民間資格です。',
};

export const courseBenefits = [
  {
    icon: 'ri-tools-line',
    title: '基本的な執事道具セット',
    description: 'プロ仕様の基本ツール一式を進呈します。',
  },
  {
    icon: 'ri-book-open-line',
    title: '教科書セット（全5冊・E1〜E5）',
    description: '全日本執事協会監修。「執事学入門」から「英国紳士の教養とたしなみ」までE群5冊を進呈。修了後も参照できる充実のセットです。',
  },
  {
    icon: 'ri-t-shirt-2-line',
    title: 'オリジナルエプロン',
    description: '実習時に着用するアカデミー特製のエプロン。',
  },
  {
    icon: 'ri-hand-sanitizer-line',
    title: '白手袋（初日支給・実習で着用）',
    description: '高品質な白手袋。執事の象徴として、初日からサービス実習で着用します。',
  },
];

export const nextStep = {
  title: '次のステップ — アドバンスコースへの編入優遇',
  description: 'エッセンシャルコース修了者がアドバンスコースへ進む場合、受講料から80,000円が減額されます。基礎を固めた後は、より高度なワインサービスやイベント運営へと領域を広げてまいりましょう。',
  discountAmount: '80,000',
};

export const admissionSteps = [
  {
    step: '01',
    title: '資料請求',
    titleEn: 'Brochure',
    description: 'まずは資料請求から。コースの詳細やアカデミーの理念をまとめた資料をお送りします。',
    icon: 'ri-file-text-line',
    href: '/brochure',
  },
  {
    step: '02',
    title: '個別相談（任意）',
    titleEn: 'Consultation',
    description: '経験豊富なスタッフが、あなたの目標やご経験に合わせた最適なコース選びをサポートします。',
    icon: 'ri-chat-3-line',
    href: '/consultation',
  },
  {
    step: '03',
    title: 'お申込み',
    titleEn: 'Apply',
    description: 'コースが決まりましたら、所定の申込フォームよりお手続きください。定員になり次第締切となります。',
    icon: 'ri-edit-line',
    href: '/apply',
  },
  {
    step: '04',
    title: '受講確定',
    titleEn: 'Confirmation',
    description: 'お申込み受付後、受講確定のご案内と事前準備資料をお送りします。開校日をお待ちください。',
    icon: 'ri-check-line',
    href: '#',
  },
];

export const relatedPages = [
  {
    title: 'アドバンスコース',
    description: 'ワインと宴会運営へ進む中級課程',
    href: '/courses/advanced',
  },
  {
    title: 'マスターコース',
    description: 'プロを目指す最上級課程',
    href: '/courses/master',
  },
  {
    title: 'コース比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses/comparison',
  },
  {
    title: '年間スケジュール',
    description: '開校時期と授業日程のご案内',
    href: '/schedule',
  },
  {
    title: '料金詳細',
    description: '受講料に含まれるものの内訳',
    href: '/pricing/details',
  },
  {
    title: 'カリキュラム',
    description: '学ぶ内容の全体像を確認',
    href: '/curriculum',
  },
];

export const faqItems = [
  {
    question: '未経験でも受講できますか？',
    answer: 'はい。エッセンシャルコースは初心者の方を前提に設計されており、受講資格は18歳以上・経験不問です。基礎の所作から段階的に学べますのでご安心ください。',
  },
  {
    question: '服装の指定はありますか？',
    answer: '授業日は白シャツ・黒系のスラックスまたはスカート・革靴をお願いしています。白手袋は初日に当アカデミーからお渡しします。詳細はお申込み後にご案内いたします。',
  },
  {
    question: '支払い方法を教えてください。',
    answer: '銀行振込による一括払いのみとなります。分割払い・クレジットカードはご利用いただけません。お支払い期限は開校日の14日前です。',
  },
];